import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { Rose } from "@ant-design/plots";

const RosePlot = () => {
  const data = [
    {
      type: "Users",
      value: 27,
    },
    {
      type: "Plans",
      value: 25,
    },
    {
      type: "Units",
      value: 18,
    },
    {
      type: "Orgs",
      value: 15,
    },
    {
      type: "Objs",
      value: 10,
    },
    {
      type: "Goals",
      value: 5,
    },
  ];
  const config = {
    data,
    height: 300,
    xField: "type",
    yField: "value",
    seriesField: "type",
    radius: 0.9,
    label: {
      offset: -15,
    },
  };
  return <Rose {...config} />;
};

export default RosePlot;
